import { z } from 'zod'
import { kExternalStorageProviders } from '@/constants/constants-external-storage'

export const ExternalStorageProviderSchema = z.enum(kExternalStorageProviders)

export const ExternalStorageAccountStatusSchema = z.enum(['connected', 'disconnected', 'error', 'reauth_required'])
export type ExternalStorageAccountStatus = z.infer<typeof ExternalStorageAccountStatusSchema>

export const ConnectedAccountSchema = z.object({
  id: z.string().uuid(),
  provider: ExternalStorageProviderSchema,
  display_email: z.string().nullable(),
  display_name: z.string().nullable(),
  status: ExternalStorageAccountStatusSchema,
  connected_at: z.string().nullable(),
  disconnected_at: z.string().nullable(),
})
export type ConnectedAccount = z.infer<typeof ConnectedAccountSchema>

export const ConnectedAccountsListResponseSchema = z.object({
  accounts: z.array(ConnectedAccountSchema),
})
export type ConnectedAccountsListResponse = z.infer<typeof ConnectedAccountsListResponseSchema>

export const ExternalStorageDisconnectFileDispositionSchema = z.enum(['keep', 'remove'])
export type ExternalStorageDisconnectFileDisposition = z.infer<typeof ExternalStorageDisconnectFileDispositionSchema>

export const ExternalStorageDisconnectPreviewSchema = z.object({
  file_count: z.number().int().nonnegative(),
  matter_count: z.number().int().nonnegative(),
})
export type ExternalStorageDisconnectPreview = z.infer<typeof ExternalStorageDisconnectPreviewSchema>

export const ExternalStorageAuthorizeResponseSchema = z.object({
  authorization_url: z.string(),
  state: z.string(),
})
export type ExternalStorageAuthorizeResponse = z.infer<typeof ExternalStorageAuthorizeResponseSchema>

export const ExternalStorageOAuthCompleteResponseSchema = z.object({
  status: z.enum(['connected', 'already_connected']),
})
export type ExternalStorageOAuthCompleteResponse = z.infer<typeof ExternalStorageOAuthCompleteResponseSchema>
